"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchInferredUserRole = getFetchInferredUserRole;

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _IdentityRepository = require("FileManagerCore/api/IdentityRepository");

function getInferredUserRoleFetchSuccededAction(inferredUserRole) {
  return {
    type: _ActionTypes.INFERRED_USER_ROLE_FETCH_SUCCEEDED,
    inferredUserRole: inferredUserRole
  };
}

function getFetchInferredUserRole(earlyRequesterPromise) {
  return function (dispatch) {
    (0, _IdentityRepository.fetchInferredUserRole)(earlyRequesterPromise).then(function (response) {
      var inferredUserRole = response.getIn(['hubUser', 'inferredRole']);

      if (inferredUserRole) {
        dispatch(getInferredUserRoleFetchSuccededAction(inferredUserRole));
      }
    });
  };
}